import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import { get } from "common/helpers/HTTP";

import type { OutreachSourceType } from "../types";

type SourceType = "campaigns" | "lists";

async function getCrmSourcesRequest(
  workspaceId: string,
  type: OutreachSourceType,
  sourceType: SourceType,
): Promise<{ id: string; name: string }[]> {
  return (
    await get(`workspaces/${workspaceId}/integrations/${type}/${sourceType}`)
  )[sourceType];
}

export default function useCrmSources({
  type,
  sourceType,
}: {
  type: OutreachSourceType;
  sourceType: SourceType;
}) {
  const { id: workspaceId } = useSelectedWorkspaceContext();

  const {
    data: crmSources,
    isLoading: iseLoadingCrmSources,
    error: crmSourcesError,
  } = useQuery({
    queryKey: [workspaceId, "crmSources", type, sourceType],
    queryFn: () => getCrmSourcesRequest(workspaceId, type, sourceType),
    enabled: !!type,
  });

  return {
    crmSources,
    iseLoadingCrmSources,
    crmSourcesError,
  };
}
